import { getApiError, type ApiError } from './basic-api-error-validator';

export const getApiErrorStatusCode = (error: unknown): number | undefined => {
  const apiError = getApiError(error);
  if (apiError) return apiError.response.status;
  return undefined;
};

export const getApiErrorCodes = (error: unknown): string[] | undefined => {
  const apiError = getApiError(error);
  if (apiError) return apiError.response.codes;
  return undefined;
};

export const validateApiError = (error: unknown): ApiError => {
  const apiError = getApiError(error);
  if (!apiError) {
    throw new Error('Error does not match the expected API error shape');
  }
  return apiError;
};
